import { render, staticRenderFns } from "./AdvertisingMap.vue?vue&type=template&id=673db4fa&scoped=true&"
import script from "./AdvertisingMap.vue?vue&type=script&lang=js&"
export * from "./AdvertisingMap.vue?vue&type=script&lang=js&"
import style0 from "./AdvertisingMap.vue?vue&type=style&index=0&id=673db4fa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "673db4fa",
  null
  
)

export default component.exports